<template>
    <BaseModal
        v-if="show"
        :title="$t('route_optimization.search_trips')"
        size="xl"
        :hide-footer="true"
        class="trip-search-modal"
        @close="$emit('close')"
    >
        <TripSearch
            ref="tripSearch"
            :available-contracts="availableContracts"
            :available-orders="availableOrders"
            :pre-selected-contract="selectedContract"
            :pre-selected-orders="selectedOrders"
            @selected-trips-changed="updateSelectedTripsCount"
        />

        <div class="modal-footer-sticky">
            <button
                type="button"
                class="btn btn-outline-secondary"
                @click="$emit('close')"
            >
                {{ $t("common.close") }}
            </button>
            <button
                v-if="tripSelectionCount > 0"
                type="button"
                class="btn btn-success"
                @click="selectRoutes"
            >
                {{ $t('route_optimization.select_routes', { count: tripSelectionCount }) }}
            </button>
        </div>
    </BaseModal>
</template>

<script>
import BaseModal from "@/components/BaseModal.vue";
import TripSearch from "./TripSearch.vue";

export default {
    name: 'TripSearchModal',
    components: {
        BaseModal,
        TripSearch
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        availableContracts: {
            type: Array,
            default: () => []
        },
        availableOrders: {
            type: Array,
            default: () => []
        },
        selectedContract: {
            type: Object,
            default: null
        },
        selectedOrders: {
            type: Array,
            default: () => []
        }
    },
    emits: ['close', 'routes-selected'],
    data() {
        return {
            tripSelectionCount: 0
        }
    },
    watch: {
        show(newVal) {
            if (!newVal) {
                this.tripSelectionCount = 0;
            }
        }
    },
    methods: {
        updateSelectedTripsCount(count) {
            this.tripSelectionCount = count;
        },

        selectRoutes() {
            const selectedTrips = this.$refs.tripSearch?.selectedTrips || [];
            const actualTrips = this.$refs.tripSearch?.searchResults || [];

            // Get actual trip data with geometry
            const tripsWithGeometry = selectedTrips.map(selectedTrip => {
                return actualTrips.find(trip => trip.id === selectedTrip.id);
            }).filter(trip => trip && trip.geometry && trip.geometry.length > 0);

            this.$emit('routes-selected', tripsWithGeometry);
            this.$emit('close');
        }
    }
}
</script>

<style scoped>
.trip-search-modal {
    position: relative;
}

.modal-footer-sticky {
    position: sticky;
    bottom: 0;
    background: white;
    border-top: 1px solid #dee2e6;
    padding: 1rem;
    display: flex;
    gap: 0.5rem;
    justify-content: flex-end;
}
</style>
